var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cc-major-btn", {
    attrs: { icon: "cci-pilot", name: "Create New Pilot" },
    on: {
      clicked: function($event) {
        return _vm.$router.push("new")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }